import React, { FC } from 'react';
import { Box } from '~Styles';
import { GetUser_User } from '../__queries__';
import CallIcon from '~Assets/icons/call.svg';
import MailIcon from '~Assets/icons/mail.svg';
import HomeIcon from '~Assets/icons/icon_home.svg';
import OrganizationIcon from '~Assets/icons/organization.svg';
import Icon from '~ComponentsImproved/Icon';
import styled from '@emotion/styled';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { useI18n } from '~Hooks';

const OrgInfoWrapper = styled(Box)`
  background-color: var(--colorBlueGray1100);
  border-radius: 8px;
`;

interface Props {
  user: GetUser_User;
}

/** Only for spanish customers who use users with invoice support */
const OrganizationInfo: FC<Props> = ({ user }) => {
  const { i18n } = useI18n();
  const isHandy = window.innerWidth <= 600;

  return (
    <OrgInfoWrapper
      display="flex"
      flexDirection={isHandy ? 'column' : 'row'}
      padding="small"
      marginTop="xs"
      gap="medium">
      <Box display="flex" flexDirection="column" gap="xs" fluid>
        {user.email && (
          <Box display="flex" gap="xs" alignItems="center">
            <Icon src={MailIcon} color="var(--colorBlueGray300)" />
            <Paragraph level={5} bottom={0} color="var(--colorBlueGray300)">
              {user.email}
            </Paragraph>
          </Box>
        )}

        <Box display="flex" gap="xs" alignItems="center">
          <Icon src={HomeIcon} color="var(--colorBlueGray300)" />
          <Box display="flex" flexDirection="column">
            <Paragraph level={5} bottom={0} color="var(--colorBlueGray300)">
              {user.address}
            </Paragraph>
            <Paragraph level={5} bottom={0} color="var(--colorBlueGray300)">
              {user.zip} {user.city}
            </Paragraph>
          </Box>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap="xs" fluid>
        {user.phone && (
          <Box display="flex" gap="xs" alignItems="center">
            <Icon src={CallIcon} color="var(--colorBlueGray300)" />
            <Paragraph level={5} bottom={0} color="var(--colorBlueGray300)">
              {user.phone}
            </Paragraph>
          </Box>
        )}

        <Box display="flex" gap="xs" alignItems="center">
          <Icon src={OrganizationIcon} color="var(--colorBlueGray300)" />
          <Box display="flex" flexDirection="column">
            <Paragraph level={5} bottom={0} color="var(--colorBlueGray300)">
              {user.invoiceType === 'PRIVATE'
                ? i18n('CustomerForCheckout.CustomerType.Private')
                : user.invoiceType}
            </Paragraph>
            <Paragraph level={5} bottom={0} color="var(--colorBlueGray300)">
              {i18n('General.OrgNr')}: {user.orgNumber}
            </Paragraph>
          </Box>
        </Box>
      </Box>
    </OrgInfoWrapper>
  );
};

export default OrganizationInfo;
